import { Box, IconButton, List, ListItemButton, TextField } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

export const OverlayContainer = styled(Box)(({ theme }) => ({
  position: 'fixed',
  top: theme.spacing(3),
  left: theme.spacing(3),
  zIndex: theme.zIndex.modal - 1,
}));

export const PanelCard = styled(Box)(({ theme }) => ({
  width: 380,
  maxWidth: 'calc(100vw - 48px)',
  borderRadius: 20,
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  background: alpha(theme.palette.background.paper, 0.86),
  backdropFilter: 'blur(20px)',
  WebkitBackdropFilter: 'blur(20px)',
  border: `1px solid ${alpha('#ffffff', 0.07)}`,
  boxShadow: '0 6px 20px rgba(0,0,0,0.22)',
}));

export const PanelHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1.25),
  padding: theme.spacing(1.25, 1.75),
  minHeight: 56,
  borderBottom: `1px solid ${alpha('#ffffff', 0.05)}`,
}));

export const HeaderIconButton = styled(IconButton)(({ theme }) => ({
  width: 36,
  height: 36,
  color: theme.palette.text.secondary,
  transition: 'color 0.2s ease, background-color 0.2s ease',
  '&:hover': {
    color: theme.palette.primary.main,
    backgroundColor: alpha(theme.palette.primary.main, 0.08),
  },
}));

export const PanelBody = styled(Box)(() => ({
  maxHeight: '62vh',
  overflowY: 'auto',
  overflowX: 'hidden',
  '&::-webkit-scrollbar': { width: 6 },
  '&::-webkit-scrollbar-track': { background: 'transparent' },
  '&::-webkit-scrollbar-thumb': {
    background: alpha('#aaaaaa', 0.2),
    borderRadius: 3,
  },
  '&::-webkit-scrollbar-thumb:hover': {
    background: alpha('#aaaaaa', 0.32),
  },
}));

export const SearchContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1.5, 1.75, 1),
}));

export const StyledTextField = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: 12,
    backgroundColor: alpha('#ffffff', 0.04),
    transition: 'background-color 0.2s ease, border-color 0.2s ease',
    '&:hover': {
      backgroundColor: alpha('#ffffff', 0.07),
    },
    '&.Mui-focused': {
      backgroundColor: alpha(theme.palette.primary.main, 0.06),
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.palette.primary.main,
        borderWidth: 1,
      },
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: alpha('#ffffff', 0.08),
    },
  },
  '& .MuiInputBase-input': {
    padding: theme.spacing(1.1, 1.5),
    fontSize: 14,
  },
}));

export const InspectionList = styled(List)(({ theme }) => ({
  padding: theme.spacing(0.5, 1, 1),
}));

export const InspectionItem = styled(ListItemButton)(({ theme }) => ({
  padding: theme.spacing(1, 1.25),
  borderRadius: 10,
  marginBottom: 2.5,
  alignItems: 'center',
  transition: 'background-color 0.2s ease, transform 0.15s ease',
  '&:hover': {
    backgroundColor: alpha(theme.palette.primary.main, 0.07),
  },
  '&:active': {
    transform: 'scale(0.99)',
  },
  '& .MuiListItemText-root': {
    marginTop: 0,
    marginBottom: 0,
  },
  '& .MuiListItemIcon-root': {
    minWidth: 32,
    color: theme.palette.text.secondary,
    transition: 'color 0.2s ease',
  },
  '&:hover .MuiListItemIcon-root': {
    color: theme.palette.primary.main,
  },
}));

export const EmptyStateBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(6, 3),
  color: theme.palette.text.secondary,
  textAlign: 'center',
}));

export const SectionLabel = styled(Box)(({ theme }) => ({
  fontSize: 11,
  fontWeight: 600,
  letterSpacing: '0.08em',
  textTransform: 'uppercase',
  color: alpha(theme.palette.text.primary, 0.45),
  padding: theme.spacing(0, 0.25),
  marginBottom: theme.spacing(1),
}));

export const StatGrid = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gap: theme.spacing(1),
}));

export const StatCard = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
  padding: theme.spacing(1.25),
  borderRadius: 12,
  backgroundColor: alpha('#ffffff', 0.035),
  border: `1px solid ${alpha('#ffffff', 0.05)}`,
}));

export const SnapshotGrid = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',
  gap: theme.spacing(1),
}));
